// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SERVER_FULL_NAME = "Modr\u00fd kon\u00edk";
export const SERVER_SLOGAN = "Str\u00e1nka pre mami\u010dky a bud\u00face mami\u010dky";
